<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      :main="$t('dashboardVue.dashboard')"
      :title="$t('conversationDetails.mzakirlrim')"
    />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col call-chat-sidebar col-sm-12">
          <div class="card">
            <div class="card-body chat-body">
              <div class="chat-box">
                <!-- Chat left side Start-->
                <div class="chat-left-aside">
                  <div class="mb-3">
                    <select
                      v-model.number="filterRequestId"
                      class="form-control"
                      @change="setSearchUsers"
                    >
                      <option value="0">
                        {{ $t('conversationDetails.btnSorular') }}
                      </option>
                      <option
                        v-for="(r, k) in uniqueRequestList"
                        :key="k"
                        :value="k"
                      >
                        {{ r }}
                      </option>
                    </select>
                  </div>

                  <div
                    id="people-list"
                    class="people-list custom-scrollbar"
                  >
                    <div class="search">
                      <form class="theme-form">
                        <div class="form-group">
                          <input
                            v-model="search"
                            class="form-control"
                            type="text"
                            :placeholder="$t('conversationDetails.axtar')"
                            @keyup="setSearchUsers"
                          ><i class="fa fa-search" />
                        </div>
                      </form>
                    </div>
                    <ul
                      v-if="search === ''"
                      class="list"
                    >
                      <li
                        v-for="c in filteredConversationList"
                        :key="c.id"
                        class="clearfix pointer"
                        @click="$router.push({name: 'conversation', params:{id: c.id, type: c.type}})"
                      >
                        <div
                          v-if="c.user.id === user.id"
                          class="p-1"
                          :class="{'bg-light': c.id === activeConversationId}"
                        >
                          <img
                            class="rounded-circle user-image"
                            :src="getPhoto(c.request?.user?.photo || c.product?.user?.photo, 'thumbnailCropped')"
                            alt=""
                          >
                          <div class="status-circle away" />
                          <div class="about">
                            <div class="name">
                              {{ c.request?.user?.name || c.product?.user?.name }}
                              {{ c.request?.user?.surname || c.product?.user?.surname }}
                            </div>
                            <div class="status">
                              #{{ c.request?.requestType || 'Product' }}{{ buildLongId(c.request?.id || c.product?.id) }}
                              <span
                                v-if="c.unReadMessageCount > 0"
                                class="badge badge-danger"
                              >{{ c.unReadMessageCount }}</span>
                            </div>
                          </div>

                          <div class="clearfix" />
                        </div>
                        <div
                          v-else
                          class="p-1"
                          :class="{'bg-light': c.id === activeConversationId}"
                        >
                          <img
                            class="rounded-circle user-image"
                            :src="getPhoto(c.user?.photo, 'thumbnailCropped')"
                            alt=""
                          >

                          <div class="about">
                            <div class="name">
                              {{ c.user?.name }} {{ c.user?.surname }}
                            </div>
                            <div class="status">
                              #{{ c.request?.requestType || 'Product' }}{{ buildLongId(c.request?.id || c.product?.id) }}
                              <span
                                v-if="c.unReadMessageCount > 0"
                                class="badge badge-danger"
                              >{{ c.unReadMessageCount }}</span>
                            </div>
                          </div>

                          <div class="clearfix" />
                        </div>
                      </li>
                    </ul>
                    <div v-else>
                      <ul class="list">
                        <li
                          v-for="c in searchResult"
                          :key="c.id"
                          class="clearfix pointer"
                          @click="$router.push({name: 'conversation', params:{id: c.id, type: c.type}})"
                        >
                          <div
                            v-if="c.user.id === user.id"
                            class="p-1"
                            :class="{'bg-light': c.id === activeConversationId}"
                          >
                            <img
                              class="rounded-circle user-image"
                              :src="getPhoto(c.request?.user?.photo || c.product?.user?.photo, 'thumbnailCropped')"
                              alt=""
                            >
                            <!--<div class="status-circle away"></div>-->
                            <div class="about">
                              <div class="name">
                                {{ c.request?.user?.name || c.product?.user?.name }}
                                {{ c.request?.user?.surname || c.product?.user?.surname }}
                              </div>
                              <div class="status">
                                #{{ c.request?.requestType || 'Product' }}{{ buildLongId(c.request?.id || c.product?.id) }}
                              </div>
                            </div>
                            <div class="clearfix" />
                          </div>
                          <div
                            v-else
                            class="p-1"
                            :class="{'bg-light': c.id === activeConversationId}"
                          >
                            <img
                              class="rounded-circle user-image"
                              :src="getPhoto(c.user?.photo, 'thumbnailCropped')"
                              alt=""
                            >
                            <!--<div class="status-circle away"></div>-->
                            <div class="about">
                              <div class="name">
                                {{ c.user?.name }} {{ c.user?.surname }}
                              </div>
                              <div class="status">
                                #{{ c.request?.requestType || 'Product' }}{{ buildLongId(c.request?.id || c.product?.id) }}
                              </div>
                            </div>

                            <div class="clearfix" />
                          </div>
                        </li>
                      </ul>
                      <div v-if="!searchResult.length">
                        <div class="search-not-found chat-search text-center">
                          <div>
                            <img
                              src="../../../assets/images/search-not-found.png"
                              alt=""
                              class="second-search"
                            >
                            <p>{{ $t('companyRateStatistics.axtaraUyunNticTaplmad') }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Chat left side Ends-->
              </div>
            </div>
          </div>
        </div>
        <div class="col call-chat-body">
          <div
            v-if="conversation"
            class="card"
          >
            <div class="card-body p-0">
              <div class="row chat-box">
                <div class="col pr-0 chat-right-aside">
                  <div class="chat">
                    <div class="chat-header clearfix">
                      <img
                        class="rounded-circle"
                        :src="getPhoto(opponent?.photo, 'thumbnailCropped')"
                        alt=""
                      >
                      <div class="about">
                        <div class="name">
                          {{ opponent?.name }} {{ opponent?.surname }}
                        </div>
                        <div class="status digits">
                          {{ opponentCompany?.name }}
                          {{ getCompanyFormat(opponentCompany?.format) }}
                        </div>
                      </div>

                      <div class="float-right mr-3">
                        <router-link
                          v-if="conversation.request"
                          class="btn btn-sm btn-outline-success"
                          :to="{name: 'request', params:{id:conversation.request.id }}"
                        >
                          {{ $t('conversationDetails.soruyaKe') }}
                        </router-link>
                        <router-link
                          v-if="conversation.product"
                          class="btn btn-sm btn-outline-success"
                          :to="{name: 'product', params:{id:conversation.product.id }}"
                        >
                          Məhsul/Xidmətə keç
                        </router-link>


                        <div v-if="!conversation.open">
                          <span class="badge badge-danger">{{ $t('feedback.bal') }}</span>
                        </div>
                        <div v-else-if="conversation.request?.user?.id === user.id">
                          <button
                            v-if="['REV', 'AUC', 'PQT'].indexOf(conversation.request?.requestType) > -1"
                            v-b-modal.modal-conversation-close
                            class="btn btn-sm btn-danger"
                          >
                            {{ $t('conversationDetails.bala') }}
                          </button>
                          <button
                            v-else
                            class="btn btn-sm btn-danger"
                            @click.prevent="closeConversation"
                          >
                            {{ $t('conversationDetails.bala') }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="chat-history chat-msg-box custom-scrollbar">
                      <div
                        class="card-body chat-box dashboard-chat"
                        style="height: auto !important;"
                      >
                        <div class="chat">
                          <div v-if="messages.length < 1">
                            <div class="search-not-found chat-search text-center">
                              <div>
                                <img
                                  src="../../../assets/images/search-not-found.png"
                                  alt=""
                                  class="second-search"
                                >
                                <p> {{ $t('conversationDetails.buMzakirdMesajYazlmayb') }}</p>
                              </div>
                            </div>
                          </div>

                          <div
                            v-for="message in messages"
                            :key="message.id"
                          >
                            <div
                              v-if="user.id !== message.userId"
                              class="media left-side-chat"
                            >
                              <img
                                class="rounded-circle chat-user-img img-60 m-r-20 mt-0"
                                :src="getPhoto(opponent?.photo, 'thumbnailCropped')"
                                alt=""
                              >
                              <div class="media-body">
                                <div class="message-main">
                                  <ConversationMessage :message="message" />
                                </div>
                              </div>
                            </div>
                            <div
                              v-else
                              class="media right-side-chat"
                            >
                              <div class="media-body text-right">
                                <div class="message-main ">
                                  <ConversationMessage :message="message" />
                                </div>
                              </div>
                              <img
                                class="rounded-circle chat-user-img img-60 m-l-20 mt-0"
                                :src="getPhoto(user?.photo, 'thumbnailCropped')"
                                alt=""
                              >
                            </div>

                            <div class="clearfix" />
                          </div>

                          <div class="my-3 p-2 border border-primary text-primary">
                            <i class="fa fa-fw fa-info-circle" />
                            {{ $t('conversationDetails.qarTrflrinSvdlmsiNOlanBtnMzakirlrinMzakirPanelindA') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="conversation.open"
                      class="chat-message clearfix"
                    >
                      <div class="row">
                        <div class="col-xl-12 d-flex">
                          <div v-if="uploadProgress > 0 && uploadProgress < 100">
                            <div
                              v-if="uploadProgress > 0 && uploadProgress < 100"
                              class="progress"
                            >
                              <div
                                class="progress-bar progress-bar-striped progress-bar-animated"
                                role="progressbar"
                                aria-valuenow="75"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                :style="{width: `${uploadProgress}%`}"
                              />
                            </div>
                          </div>
                          <div
                            v-else
                            class="smiley-box bg-primary"
                          >
                            <input
                              id="fileInput"
                              ref="file"
                              type="file"
                              style="display: none"
                              @change="setAttachment"
                            >
                            <div
                              class="picker"
                              @click.prevent="selectAttachment"
                            >
                              <img
                                src="@/assets/images/attachment.png"
                                alt=""
                              >
                            </div>
                          </div>
                          <div class="input-group text-box">
                            <input
                              id="message-to-send"
                              v-model="messageText"
                              class="form-control input-txt-bx"
                              type="text"
                              name="message-to-send"
                              :placeholder="$t('conversationDetails.mesajnz')"
                              @keyup.enter="sendMessage()"
                            >
                            <div class="input-group-append">
                              <button
                                class="btn btn-primary"
                                type="button"
                                @click="sendMessage()"
                              >
                                {{ $t('body.gndr') }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-else
                      class="chat-message clearfix"
                    >
                      {{ $t('conversationDetails.mzakirBaldr') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="card"
          >
            <div class="card-body text-center text-secondary">
              <feather
                type="message-square"
                size="70"
                stroke="#aaa"
                :stroke-width="1"
              />
              <br>

              <p>
                {{ $t('conversationDetails.zhmtOlmasaDavamEtmkNMzakirniSein') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-conversation-close"
      centered
      :title="$t('conversationDetails.mzakirninBalanmas')"
      ok-only
      ok-title="ləğv et"
      class="theme-modal"
    >
      <div>
        <p class="lead">
          {{ $t('conversationDetails.zhmtOlmasaMzakirninNticsiniBildirin') }}
        </p>

        <div v-if="unsuccessReasonIsOpen">
          <div class="list-group">
            <button
              v-for="r in auctionUnSuccessReasons"
              :key="r"
              type="button"
              class="list-group-item list-group-item-action"
              @click.prevent="closeAuctionConversation(0, r)"
            >
              {{ r }}
            </button>
          </div>
          <br>
          <a
            class="btn btn-danger my-3"
            @click.prevent="unsuccessReasonIsOpen = false"
          >
            {{ $t('companyProfile.lvEt') }}
          </a>
        </div>

        <p
          v-else
          class="text-center"
        >
          <a
            class="btn btn-success my-3"
            @click.prevent="closeAuctionConversation(1)"
          >
            {{ $t('conversationDetails.mzakirUurluOldu') }}
          </a>
          <a
            class="btn btn-danger my-3"
            @click.prevent="unsuccessReasonIsOpen = true"
          >
            {{ $t('conversationDetails.mzakirUursuzOldu') }}
          </a>
        </p>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  closeConversation as closeRequestConversation,
  getConversationDetails as getRequestConversationDetails,
  getMyConversations as getMyRequestConversations,
  sendConversationMessage as sendRequestConversationMessage, upload,
} from "@/repositories/GeneralDataRepository";
import {
  closeConversation as closeProductConversation,
  getConversation as getProductConversationDetails,
  myConversations as getMyProductConversations,
  sendMessage as sendProductConversationMessage
} from "@/repositories/ProductConversationDataRepository";
import { mediaBase } from "@/repositories/Repository";
import { buildLongId, getCompanyFormat, getPhoto, getProfileName } from "@/repositories/Utils";
import ConversationMessage from "@/pages/scc/request/ConversationMessage.vue";

export default {
  components: { ConversationMessage },
  data() {
    return {
      mediaBase: mediaBase,
      conversations: [],
      status: 'active',
      search: '',
      searchResult: [],
      activeConversationId: 0,
      activeConversationType: '',
      conversation: null,
      messages: [],
      opponent: null,
      opponentCompany: null,
      messageText: '',
      updateConversationTimer: null,
      updateMessageTimer: null,
      uploadProgress: 0,
      unsuccessReasonIsOpen: false,
      auctionUnSuccessReasons: [
        this.$t("conversationDetails.mzkrQatl"),
        this.$t("conversationDetails.noAgreement"),
        this.$t("conversationDetails.fakePrice"),
        this.$t("conversationDetails.tklfMhslygnOlmadi"),
        this.$t("conversationDetails.mzkrPortalKnr"),
      ],
      filterRequestId: 0
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),

    uniqueRequestList() {
      let map = {};

      this.conversations.forEach((c) => {
        const requestId = c.request ? c.request.id : c.product.id;
        const requestType = c.request ? c.request?.requestType : 'Product';

        if (!map[requestId]) {
          map[requestId] = `${requestType}${buildLongId(requestId, 5)}`;
        }
      });

      return map;
    },

    filteredConversationList() {
      return this.conversations.filter(c => {
        return this.filterRequestId === 0 || (this.filterRequestId > 0 && (c.request?.id === this.filterRequestId || c.product?.id === this.filterRequestId));
      })
    }
  },
  watch: {
    activeConversationId() {
      this.getConversationDetails();
    },
    "$route"() {
      this.activeConversationId = parseInt(this.$route.params['id']) || 0;
      this.activeConversationType = this.$route.query.conversation_type || 'request';
    },
    messages: {
      deep: true,
      handler: () => {
        let container = document.querySelector(".chat-history");
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      }
    }
  },
  mounted() {
    this.activeConversationId = parseInt(this.$route.params['id']) || 0;
    this.activeConversationType = this.$route.query.conversation_type || 'product';
    this.getMyConversations();

    this.updateMessageTimer = setInterval(() => {
      if (this.activeConversationId > 0 && this.conversation !== null && this.conversation.open === true) {
        this.getConversationDetails();
        console.log(1);
      } else {
        console.log(2);
      }
    }, 3000);

    this.updateConversationTimer = setInterval(() => {
      this.getMyConversations();
    }, 3000);
  },

  beforeDestroy() {
    if (this.updateMessageTimer) {
      clearInterval(this.updateMessageTimer);
    }
    if (this.updateConversationTimer) {
      clearInterval(this.updateConversationTimer);
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.activeConversationType = to.query.conversation_type || 'request';
    });
  },
  beforeRouteUpdate (to, from, next) {
    this.activeConversationType = to.query.conversation_type || 'request';
    next();
  },
  methods: {
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },

    getMyConversations() {
      Promise.all([
        getMyRequestConversations(this.token),
        getMyProductConversations(this.token)
      ]).then(([requestConversations, productConversations]) => {
        if (requestConversations.code === 200 && productConversations.code === 200) {
          const requestConvs = requestConversations.conversations.map(c => ({...c, type: 'request'}));
          const productConvs = productConversations.conversations.map(c => ({...c, type: 'product'}));
          this.conversations = [...requestConvs, ...productConvs];
        } else {
          this.$swal({
            title: `Error`,
            text: `${requestConversations.message || productConversations.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },
    async getConversationDetails() {
      const tryRequestConversation = async () => {
        try {
          const data = await getRequestConversationDetails(this.token, this.activeConversationId);
          if (data.code === 200) {
            this.conversation = data.conversation;
            this.messages = data.messages;

            if (data.conversation.user.id === this.user.id) {
              this.opponent = data.conversation.request.user;
              this.opponentCompany = data.conversation.request.company;
            } else {
              this.opponent = data.conversation.user;
              this.opponentCompany = data.conversation.company;
            }

            this.activeConversationType = 'request';
            return true;
          }
        } catch (error) {
          console.error('Request conversation not found:', error);
          return false;
        }
      };

      const tryProductConversation = async () => {
        try {
          const data = await getProductConversationDetails(this.token, this.activeConversationId);
          if (data.code === 200) {
            this.conversation = data.conversation;
            this.messages = data.messages;

            if (data.conversation.user.id === this.user.id) {
              this.opponent = data.conversation.product.user;
              this.opponentCompany = data.conversation.product.company;
            } else {
              this.opponent = data.conversation.user;
              this.opponentCompany = data.conversation.company;
            }

            this.activeConversationType = 'product';
            return true;
          }
        } catch (error) {
          console.error('Product conversation not found:', error);
          return false;
        }
      };

      const found = await tryProductConversation();
      if (!found) {
        const foundProduct = await tryRequestConversation();
        if (!foundProduct) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("buMzkrMvcdDyl"),
            icon: 'error'
          }).then(() => {
            this.$router.push('/dashboard/conversation/0');
          });
        }
      }
    },
    setSearchUsers() {
      let list = [];

      this.conversations.forEach(c => {
        let searchTerm = this.search.toLowerCase().trim();

        if (
            (c.user.id !== this.user.id && (
                c.user.name.toLowerCase().indexOf(searchTerm) > -1
                || c.user.surname.toLowerCase().indexOf(searchTerm) > -1
            )) ||
            (c.user.id === this.user.id && (
                c.request?.user?.name.toLowerCase().indexOf(searchTerm) > -1
                || c.request?.user?.surname.toLowerCase().indexOf(searchTerm) > -1
                || c.product?.user?.name.toLowerCase().indexOf(searchTerm) > -1
                || c.product?.user?.surname.toLowerCase().indexOf(searchTerm) > -1
            ))
        ) {
          if (this.filterRequestId === 0 || (this.filterRequestId > 0 && (c.request?.id === this.filterRequestId || c.product?.id === this.filterRequestId))) {
            list.push(c);
          }
        }
      });

      this.searchResult = list;
    },
    sendMessage() {
      if (this.messageText.trim() !== '') {
        const sendMessageMethod = this.activeConversationType === 'product' ? sendProductConversationMessage : sendRequestConversationMessage;
        sendMessageMethod(this.token, this.conversation.id, 'TEXT', this.messageText.trim(), '{}').then(data => {
          if (data.code === 200) {
            this.messageText = '';
            this.getConversationDetails();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            });
          }
        });
      }
    },
    closeConversation() {
      if (confirm(this.$t("mzkrnBglmqIstdyMnsnz"))) {
        const closeConversationMethod = this.activeConversationType === 'product' ? closeProductConversation : closeRequestConversation;
        closeConversationMethod(this.token, this.conversation.id, 0, '').then(data => {
          if (data.code === 200) {
            this.getConversationDetails();
          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            });
          }
        });
      }
    },
    closeAuctionConversation(isSuccess, reason) {
      const closeConversationMethod = this.activeConversationType === 'product' ? closeProductConversation : closeRequestConversation;
      if (isSuccess) {
        this.$swal({
          title: this.conversation.request?.requestType === 'PQT' ? this.$t("conversationDetails.ugurluSxsqalibOlacaq") : this.$t("conversationDetails.ugurluHorcaOlacaq"),
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: this.$t("conversationDetails.qalibElanEt"),
          cancelButtonText: this.$t("companyProfile.lvEt")
        }).then((result) => {
          if (result.value) {
            closeConversationMethod(this.token, this.conversation.id, isSuccess, '').then(data => {
              if (data.code === 200) {
                this.getConversationDetails();
                this.$router.push(`/dashboard/request/${this.conversation.request.id}`);
              } else {
                this.$swal({
                  title: `Error ${data.code}`,
                  text: `${data.message}`,
                  icon: 'error'
                });
              }
            });
          }
        });
      } else {
        this.$swal({
          title: this.$t("conversationDetails.istfidaUgursuzBagla"),
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: this.$t("conversationDetails.mzkrnBagla"),
          cancelButtonText: this.$t("companyProfile.lvEt")
        }).then((result) => {
          if (result.value) {
            closeConversationMethod(this.token, this.conversation.id, isSuccess, reason).then(data => {
              if (data.code === 200) {
                this.getConversationDetails();
                this.$router.push(`/dashboard/request/${this.conversation.request.id}`);
              } else {
                this.$swal({
                  title: `Error ${data.code}`,
                  text: `${data.message}`,
                  icon: 'error'
                });
              }
            });
          }
        });
      }
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    selectAttachment() {
      window.document.getElementById('fileInput').click();
    },
    setAttachment() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {
        this.uploadMessage = '';
        upload(this.token, 'conversationPhoto', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        }).then(response => {
          this.uploadProgress = 100;
          if (response.data.code === 200) {
            let messageData = { path: response.data.path };
            const sendMessageMethod = this.activeConversationType === 'product' ? sendProductConversationMessage : sendRequestConversationMessage;
            sendMessageMethod(this.token, this.conversation.id, "PHOTO", "", JSON.stringify(messageData)).then(data => {
              if (data.code === 200) {
                this.commentText = '';
                this.getConversationDetails();
              } else {
                this.$swal({
                  title: `Error ${data.code}`,
                  text: `${data.message}`,
                  icon: 'error'
                });
              }
            });
          } else {
            this.$swal({
              title: `Error ${response.data.code}`,
              text: `${response.data.message}`,
              icon: 'error'
            });
          }
        }).catch((e) => {
          console.log(e);
          this.progress = 0;
          this.$swal({
            title: `Error`,
            text: this.$t("cldNotUploadFile") + e,
            icon: 'error'
          });
        });
      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'warning'
        });
      }
    },
  }
}
</script>

<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
